import { Component, Input, OnInit } from '@angular/core';
import { AssignmentRulesEvent } from '../../../../shared/models/common/assigmentRules/assignmentRulesEvent';
import { EventService } from '../../../../shared/services/event/event.service';
import { UserService } from '../../../../shared/services/user/user.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-user-selection-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class UserSelectionDropdownComponent extends DropdownBaseComponent implements OnInit {

  @Input() loadOnInit = true;
  itemsLoaded = false;

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly userService: UserService,
    protected readonly translatorService: TranslatorService,
    private readonly eventService: EventService,
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);

    if (this.loadOnInit) {
      this.loadUsers();
    }

    this.itemDeSelectedFunction = function(): void {
      this.eventService.broadcast(AssignmentRulesEvent.ASSIGNMENT_RULE_USER_SELECTED, 0);
    };
  }

  loadUsers() {

    if (this.itemsLoaded) {
      return;
    }

    this.userService.usersQuery$(null, null).subscribe(res => {
      const listUser = [];
      for (const user of res.userList) {
        listUser.push({ id: user.id, name: `${user.name} ${user.lastName}` });
      }
      this.itemsData = this.itemsData.concat(listUser);
    });
  }

  selectItem($event: any) {
    const item = this.itemsData.find(data => data.id === $event.id);
    this.itemSelectedFunction(item);
    this.eventService.broadcast(AssignmentRulesEvent.ASSIGNMENT_RULE_USER_SELECTED, 1);
  }
}
